export const changeDateToStartAtMidnight = (d: Date | null = null) => {
  const newDate = d ?? Date.now() - 7 * 24 * 60 * 60 * 1000
  const date = new Date(newDate)
  date.setHours(1, 0, 0, 0)
  return date
}
